import { LogoMark } from "./Logo";
import { BRAND, PHONE_DISPLAY, PHONE_TEL, ZONES } from "../constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#05070A] pt-20 overflow-hidden">
    <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-12 pb-20">
      <div>
        <div className="flex items-center gap-3 mb-6">
          <LogoMark className="w-10 h-10" />
          <span className="font-display font-semibold text-xl tracking-tight">{BRAND}</span>
        </div>
        <p className="text-sm text-[#94A3B8] leading-relaxed max-w-xs">
          Assistenza caldaie e condizionatori a domicilio. Pronto intervento,
          manutenzione e installazione con preventivo gratuito.
        </p>
      </div>
      <div>
        <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#00D2FF] mb-6">
          Zone coperte
        </p>
        <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm text-[#94A3B8]" data-testid="footer-zones">
          {ZONES.map((z) => (
            <li key={z}>{z}</li>
          ))}
        </ul>
      </div>
      <div>
        <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#FF6B00] mb-6">
          Contatti diretti
        </p>
        <a
          href={PHONE_TEL}
          data-testid="footer-phone-link"
          className="font-display font-medium text-2xl tracking-tight hover:text-[#FF6B00] transition-colors duration-300"
        >
          {PHONE_DISPLAY}
        </a>
        <a
          href="mailto:fcimpianti2026@gmail.com"
          data-testid="footer-email-link"
          className="block mt-3 text-sm text-[#94A3B8] hover:text-[#00D2FF] transition-colors duration-300 break-all"
        >
          fcimpianti2026@gmail.com
        </a>
        <p className="mt-4 text-sm text-[#94A3B8]">
          Lun – Dom, 8:00 – 20:00
          <br />
          Pronto intervento anche nei festivi
        </p>
      </div>
    </div>

    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <p
        data-testid="footer-brand-watermark"
        className="font-display font-semibold tracking-tighter text-[18vw] leading-[0.8] text-white/[0.04] select-none text-center -mb-[4vw]"
      >
        {BRAND}
      </p>
    </div>

    <div className="border-t border-white/10 py-6">
      <div className="mx-auto max-w-7xl px-6 md:px-12 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#94A3B8]/60 font-mono-tech uppercase tracking-[0.15em]">
        <span>© 2026 {BRAND} — P.IVA 17885681001</span>
        <span>Assistenza termoidraulica a domicilio</span>
      </div>
    </div>
  </footer>
);
